module.exports = __webpack_public_path__ + "assets/adpoly-facility-auditoriums-bulk-upload-template.a8d502ff.xlsx";